<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent" style="height:auto">
      <div class="wrap">
        <div class="content">
          <h5 class="page-title">
            <span class="blue title-line"></span> 企业认证
          </h5>
          <div class="main-box">
            <!-- <div class="section">
              <el-steps :active="active" simple class="my-steps">
                <el-step title="填写信息">
                  <img
                    class="stepsIcon"
                    src="@/assets/images/steps2-2.png"
                    alt=""
                    slot="icon"
                  />
                </el-step>

                <el-step title="提交资料，并完成汇款">
                  <img
                    class="stepsIcon"
                    src="@/assets/images/steps1.png"
                    alt=""
                    slot="icon"
                  />
                </el-step>

                <el-step title="审核完成">
                  <img
                    class="stepsIcon"
                    src="@/assets/images/steps3.png"
                    alt=""
                    slot="icon"
                  />
                </el-step>
              </el-steps>
            </div> -->

            <div class="form">
              <el-form
                :model="applyForm"
                :rules="applyrules"
                ref="applyForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <div class="kuang">
                  <h5 class="page-title">
                    <span class="blue title-line"></span> 请填写您的单位信息
                  </h5>
                  <el-form-item
                    label="企业名称:"
                    label-width="130px"
                    prop="name"
                  >
                    <el-input
                      v-model="applyForm.name"
                      placeholder="请输入单位证件登记的名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="单位证件号:"
                    label-width="130px"
                    prop="uscc"
                  >
                    <el-input
                      v-model="applyForm.uscc"
                      placeholder="请输入统一的社会信用代码或组织机构代码"
                    ></el-input>
                  </el-form-item>
                </div>

                <div class="kuang">
                  <h5 class="page-title">
                    <span class="blue title-line"></span>
                    请填写您的银行对公账户信息
                  </h5>
                  <el-form-item
                    label="银行开户名:"
                    label-width="130px"
                    prop="name"
                  >
                    <el-input
                      disabled
                      v-model="applyForm.name"
                      placeholder="银行开户名和企业名称保持一致"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="开户银行:"
                    label-width="130px"
                    prop="bankName"
                  >
                    <el-input
                      v-model="applyForm.bankName"
                      placeholder="请输入企业账户开户银行"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="银行账号:"
                    label-width="130px"
                    prop="bankNo"
                  >
                    <el-input
                      v-model="applyForm.bankNo"
                      placeholder="请输入企业对公账号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="开户支行:"
                    label-width="130px"
                    prop="bankSubbranch"
                  >
                    <el-input
                      v-model="applyForm.bankSubbranch"
                      placeholder="请输入开户支行名称"
                    ></el-input>
                  </el-form-item>
                </div>

                <div class="kuang">
                  <h5 class="page-title">
                    <span class="blue title-line"></span> 请填写联系方式
                  </h5>
                  <el-form-item
                    label="联系人姓名:"
                    label-width="130px"
                    prop="contactsName"
                  >
                    <el-input
                      v-model="applyForm.contactsName"
                      placeholder="请输入联系人姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系邮箱:" label-width="130px">
                    <el-input
                      v-model="applyForm.email"
                      placeholder="请输入联系人邮箱"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="联系人手机号码:"
                    label-width="130px"
                    prop="contactsPhone"
                  >
                    <el-input
                      v-model="applyForm.contactsPhone"
                      placeholder="请输入联系人手机号码"
                    ></el-input>
                  </el-form-item>
                  <div class="yzm-item">
                    <el-form-item
                      label="验证码:"
                      label-width="130px"
                      prop="code"
                    >
                      <el-input
                        v-model="applyForm.code"
                        placeholder="短信验证码"
                      ></el-input>
                    </el-form-item>
                    <span :disabled="disabled" @click="getVerificationCode">{{
                      yzmtext
                    }}</span>
                  </div>
                  <div class="uploads">
                    <div class="upload_title">
                      请上传企业营业执照<b style="color: red">*</b>
                    </div>
                    <div class="format">
                      图片格式要求jpg、jpeg、png，不超过10M；
                    </div>
                    <div class="uploadlist">
                      <Upload
                        message="企业营业执照"
                        sort="1"
                        @uploadData="getChildData($event)"
                        @delpic="delimg($event)"
                      ></Upload>
                    </div>
                    <p class="warning">
                      <i class="el-icon-warning"></i
                      >&nbsp;&nbsp;&nbsp;&nbsp;请务必提供真实信息，公司有权自行或委托第三方，审查提供的身份是否真实、有效。若提供虚假信息，由此带来的后果由提供方承担。
                    </p>
                  </div>
                  <div class="submit">
                    <span @click="next('applyForm')">下一步</span>
                    <b @click="cancel">取消认证</b>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="captcha-element"></div>
  </el-row>
</template>

<script>
import Upload from "@/components/Upload.vue";
import { Loading } from "element-ui";
import NoTrace from '@/utils/noTrace';
import {sendMsg} from '@http/user_center/realName'
import qs from "qs";
var interval = null;

export default {
  data() {
    var vphone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      }
      callback();
    };
    var vuscc = (rule, value, callback) => {
      if (!/^[A-Za-z0-9-]{6,40}$/.test(value)) {
        callback(new Error("单位证件号格式不正确"));
      }
      callback();
    };

    return {
      formData: {},
      imgs: {},
      active: 0,
      applyForm: {
        name: "",
        bankAccountName: "",
        uscc: "",
        bankName: "",
        bankNo: "",
        bankSubbranch: "",
        contactsName: "",
        email: "",
        contactsPhone: "",
        code: "",
        legal: "张三",
      },
      applyrules: {
        name: [
          {
            required: true,
            message: "请输入单位证件登记的名称",
            trigger: "blur",
          },
        ],
        uscc: [
          {
            required: true,
            message: "请输入统一的社会信用代码或组织机构代码",
            trigger: "blur",
          },
          { validator: vuscc, trigger: "blur" },
        ],
        bankName: [
          {
            required: true,
            message: "请输入企业账户开户银行",
            trigger: "blur",
          },
        ],
        bankNo: [
          { required: true, message: "请输入企业对公账号", trigger: "blur" },
        ],
        bankSubbranch: [
          { required: true, message: "请输入开户支行名称", trigger: "blur" },
        ],
        contactsName: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        contactsPhone: [
          { required: true, message: "请输入联系人手机号码", trigger: "blur" },
          { validator: vphone, trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      yzmtext: "获取验证码",
      disabled: false,
      currentTime: 60,
    };
  },
  components: {
    Upload,
  },

  computed: {},

  created() {
    
  },

  mounted() {
      NoTrace.init('captcha-element', 'captcha-button')
  },
  beforeDestroy() {
      NoTrace.reset()
  },

  methods: {
    async getVerificationCode() {
      if (!/^1[3456789]\d{9}$/.test(this.applyForm.contactsPhone)) {
        this.$msg("请输入正确的手机号");
        return false;
      }
      this.getCode();
      var that = this;
      that.disabled = true;
      // 开始获取无痕验证码
      NoTrace.start((nvc) => {
          this.nvc = nvc
      }, this.executeFun, {
          phone: that.applyForm.contactsPhone,
          nvc: '',
          afsVersion: 2
      })
    },
    executeFun (params) {
        let that=this;
        return new Promise(async (resolve, reject) => {
            try {
                let res = await sendMsg(params);
                resolve(res)
                that.$msg("验证码已发送，请注意接收", "success");
            }catch (err) {
                reject(err)
                that.$msg('发送失败')
                clearInterval(interval);
                that.currentTime = 60;
                that.yzmtext = "重新获取";
                that.disabled = false;
            }
        })
    },

    getCode() {
      var that = this;
      var currentTime = that.currentTime;
      interval = setInterval(function () {
        currentTime--;
        that.yzmtext = "(" + currentTime + "s)重新获取";
        if (currentTime <= 0) {
          clearInterval(interval);
          that.yzmtext = "重新获取";
          that.currentTime = 60;
          that.disabled = false;
        }
      }, 1000);
    },
    getChildData(data) {
      if (data == {}) {
        this.imgs = data;
      } else {
        for (var key in data) {
          this.imgs[key] = data[key];
        }
      }
      console.log(this.imgs);
    },
    delimg(data) {
      if (data) {
        console.log(data);
        var arr = Object.keys(this.imgs);
        if (arr.length > 1) {
          for (var key in data) {
            console.log(this.imgs[key]);
            delete this.imgs[key];
          }
        } else {
          this.imgs = {};
        }
        console.log(this.imgs);
      }
    },
    next(formName) {
      this.formData = new FormData();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          this.applyForm.bankAccountName = this.applyForm.name;
          let clientId = this.$getlocalStorage("queryData")
            ? this.$getlocalStorage("queryData").clientId
            : "";
          if (clientId) {
            this.applyForm = Object.assign({}, this.applyForm, { clientId });
          }
          Object.keys(that.applyForm).forEach((key) => {
            that.formData.append(key, that.applyForm[key]);
          });
          // this.formData.append("param", JSON.stringify(this.applyForm));
          this.formData.append("file", this.imgs[1]);
          let loadingInstance = Loading.service({
            background: "rgba(255,255,255,.5)",
          });
          this.$request({
            method: "post",
            url: "/identification/enterprise/apply",
            data: that.formData,
          })
            .then((res) => {
              that.$nextTick(() => {
                loadingInstance.close();
              });
              console.log(res);
              this.$router.push({ path: "/userCenter/Entercheck" });
            })
            .catch((err) => {
              that.$nextTick(() => {
                loadingInstance.close();
              });
              that.$msg(err.message);
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      this.$router.replace({ path: "/userCenter/AuthenticationName" });
    },
  },
};
</script>
<style src="@/assets/css/content.css" scoped></style>

<style scoped>
 .mianContent{
  height: auto;
}
.main-box {
  width: 940px;
  margin: 0 auto;
}
.form {
  margin-top: 30px;
}
.kuang {
  box-sizing: border-box;
  margin-bottom: 20px;
  padding: 32px;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 4px 6px 0px rgba(172, 172, 172, 0.18);
}
.kuang .page-title {
  margin-bottom: 30px;
}
.form .el-form-item {
  width: 600px;
}
.yzm-item {
  width: 600px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.yzm-item .el-form-item {
  width: 400px;
}
.yzm-item span {
  width: 148px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #fff;
  color: #3f7df7;
  cursor: pointer;
  border: 1px solid #3f7df7;
  font-size: 14px;
}
.yzm-item span:hover {
  background: #3f7df7;
  color: #fff;
}
.yzm-item span[disabled] {
  color: #fff;
  background: #bcbcbc;
  pointer-events: none;
  cursor: inherit;
  border-color: #bcbcbc;
}
.uploads {
  padding-top: 10px;
  text-align: left;
}
.upload_title {
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
}
.format {
  color: #999;
  font-size: 14px;
}

.uploadlist {
  padding-top: 15px;
  width: 186px;
}
.uploads .warning {
  font-size: 14px;
  margin-top: 14px;
}
.submit {
  margin-top: 32px;
  text-align: left;
}
.submit span {
  display: inline-block;
  text-align: center;
  width: 148px;
  height: 40px;
  line-height: 40px;
  color: #3080fe;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #3080fe;
}
.submit b {
  margin-left: 30px;
  display: inline-block;
  text-align: center;
  width: 148px;
  height: 40px;
  line-height: 40px;
  color: #999;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #ccc;
}
.submit b:hover {
  color: #333;
  background: #f5f5f5;
}
.submit span:hover {
  background: #3080fe;
  color: #fff;
}
</style>
<style>
.my-steps .el-step__icon.is-text {
  border: none;
}
.my-steps .el-step.is-simple .el-step__icon {
  width: 65px;
  height: 46px;
}
.my-steps .el-step__icon {
  border: none;
}
.my-steps .el-step.is-simple .el-step__head {
  padding: 0;
}
.my-steps .stepsIcon {
  margin-right: 20px;
  width: 46px;
  height: 46px;
}
.my-steps {
  background: #fff;
  padding: 13px 5%;
}
/* .form .el-form-item__label{
    text-align: left;
} */
</style>
